import { apiCall, ApiResult } from './core';

// Jira Integration API
export const jiraAPI = {
  // Get Jira connection status
  getStatus: async (): Promise<ApiResult> => {
    try {
      const data = await apiCall('/integrations/jira/status');
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  },

  // Initiate Jira OAuth connection
  connect: async (): Promise<ApiResult> => {
    try {
      const data = await apiCall('/integrations/jira/connect', {
        method: 'POST'
      });
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  },

  // Disconnect Jira integration
  disconnect: async (): Promise<ApiResult> => {
    try {
      const data = await apiCall('/integrations/jira/disconnect', {
        method: 'POST'
      });
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  },

  // Get available Jira projects
  getProjects: async (): Promise<ApiResult> => {
    try {
      const data = await apiCall('/integrations/jira/projects');
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  },

  // Configure a project with Jira
  configureProject: async (projectId: string, jiraProjectKey: string, jiraProjectName: string, milestoneSource: string): Promise<ApiResult> => {
    try {
      const data = await apiCall('/integrations/jira/configure', {
        method: 'POST',
        body: JSON.stringify({
          project_id: projectId,
          jira_project_key: jiraProjectKey,
          jira_project_name: jiraProjectName,
          milestone_source: milestoneSource
        })
      });
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  },

  // Remove Jira configuration from a project
  removeProject: async (projectId: string): Promise<ApiResult> => {
    try {
      const data = await apiCall(`/integrations/jira/projects/${projectId}`, {
        method: 'DELETE'
      });
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  },

  // Sync Jira data (milestones/sprints)
  sync: async (): Promise<ApiResult> => {
    try {
      const data = await apiCall('/integrations/jira/sync', {
        method: 'POST'
      });
      return { success: true, data };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  }
};

export const awsEnvironmentsAPI = {
  getEnvironments: async (clientId: string | null = null): Promise<ApiResult> => {
    try {
      let endpoint = '/aws/environments';
      if (clientId) {
        endpoint += `?client_id=${clientId}`;
      }
      const data = await apiCall(endpoint);
      return { success: true, data: Array.isArray(data) ? data : [] };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  },

  getAccounts: async (clientId: string | null = null): Promise<ApiResult> => {
    try {
      let endpoint = '/aws/accounts';
      if (clientId) {
        endpoint += `?client_id=${clientId}`;
      }
      const data = await apiCall(endpoint);
      return { success: true, data: Array.isArray(data) ? data : [] };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return { success: false, error: err.message };
    }
  }
};
